class Mercury {
  static connect(registration, url) {
    this.current = new Mercury(registration);
    this.current.connect(url);
    return this.current;
  }

  static disconnect() {
    var i, len, ref, results, sub;

    if (!this.current) {
      return;
    }

    ref = this.current.cable.subscriptions.subscriptions;
    results = [];

    for (i = 0, len = ref.length; i < len; i++) {
      sub = ref[i];
      results.push(sub.unsubscribe());
    }

    return results;
  }

  static on(conditions, callback) {
    return this.current.on(conditions, callback);
  }

  static off(conditions, callback) {
    return this.current.off(conditions, callback);
  }

  static subscriptions() {
    if (this.current) {
      return this.current.subscriptions;
    } else {
      return {};
    }
  }

  static push(subscription, text, callback) {
    return this.current.push(subscription, text, callback);
  }

  static history(subscription) {
    return this.current.history(subscription);
  }

  static destroy(subscription_uuid, message_uuid) {
    return this.current.destroy(subscription_uuid, message_uuid);
  }

  static markAsRead(subscription_uuid, message_uuid) {
    return this.current.markAsRead(subscription_uuid, message_uuid);
  }

  constructor(data) {
    this.registration = data;
    this.subscriptions = [];
    this.callbacks = {};
    this.channels = {};
  }

  connect(url) {
    this.cable = ActionCable.createConsumer(url);
    return this.register();
  }

  register() {
    return this.channels.registration = this.cable.subscriptions.create("RegistrationChannel", {
      connected: function () {
        return this.perform("register", Mercury.current.registration);
      },
      received: function (data) {
        return Mercury.current.update(data);
      }
    });
  }

  on(conditions, cb) {
    var key;
    key = this.conditionKey(conditions);

    if (!key) {
      return;
    }

    if (!this.callbacks[key]) {
      this.callbacks[key] = [];
    }

    return this.callbacks[key].push(cb);
  }

  off(conditions) {
    var key;
    key = this.conditionKey(conditions);

    if (key) {
      return this.callbacks[key] = [];
    } else {
      return this.callbacks = {};
    }
  }

  trigger(conditions, payload) {
    var callbacks, cb, i, key, len, results;
    key = this.conditionKey(conditions);
    callbacks = this.callbacks[key];

    if (callbacks) {
      results = [];

      for (i = 0, len = callbacks.length; i < len; i++) {
        cb = callbacks[i];

        if (payload.length === void 0 || payload.length === 1) {
          results.push(cb.call(this, payload));
        } else {
          results.push(cb.apply(this, payload));
        }
      }

      return results;
    }
  }

  push(subscription, text, callback) {
    var channel, uuid;
    uuid = typeof subscription === "string" ? subscription : subscription.uuid;
    channel = this.channels[uuid];
    channel.perform("push", {
      content: text
    });
    return callback(channel);
  }

  destroy(subscription_uuid, message_uuid) {
    var channel;
    channel = this.channels[subscription_uuid];
    return channel.perform("destroy", {
      uuid: message_uuid
    });
  }

  markAsRead(subscription_uuid, message_uuid) {
    var channel;
    channel = this.channels[subscription_uuid];
    return channel.perform("mark_as_read", {
      uuid: message_uuid
    });
  }

  history(subscription) {
    return this.channels[subscription.uuid].history();
  }

  conditionKey(conditions) {
    if (typeof conditions === "string") {
      return conditions;
    } else if (conditions.uuid) {
      return "uuid:" + conditions.uuid;
    } else if (conditions.type) {
      return "type:" + conditions.type;
    }
  }

  update(registrationUpdate) {
    var existingSubs, i, j, len, len1, ref, ref1, s, subscription, updatedSubs;
    this.registration = registrationUpdate;

    existingSubs = function () {
      var i, len, ref, results;
      ref = this.subscriptions;
      results = [];

      for (i = 0, len = ref.length; i < len; i++) {
        s = ref[i];
        results.push(s.uuid);
      }

      return results;
    }.call(this);

    updatedSubs = function () {
      var i, len, ref, results;
      ref = this.registration.user.subscriptions;
      results = [];

      for (i = 0, len = ref.length; i < len; i++) {
        s = ref[i];
        results.push(s.uuid);
      }

      return results;
    }.call(this);

    ref = this.registration.user.subscriptions;

    for (i = 0, len = ref.length; i < len; i++) {
      subscription = ref[i];

      if (existingSubs.indexOf(subscription.uuid) === -1) {
        this.addSubscription(subscription);
      }
    }

    ref1 = this.subscriptions;

    for (j = 0, len1 = ref1.length; j < len1; j++) {
      subscription = ref1[j];

      if (updatedSubs.indexOf(subscription.uuid) === -1) {
        this.removeSubscription(subscription);
      }
    }

    return this.trigger("register", this.registration);
  }

  removeSubscription(subscription) {
    return this.trigger("unsubscribe", subscription);
  }

  addSubscription(subscription) {
    var identifier, mercury, uuid;
    uuid = subscription.uuid;
    identifier = {
      channel: "SubscriptionChannel",
      uuid: uuid
    };
    mercury = this;
    return this.channels[uuid] = this.cable.subscriptions.create(identifier, {
      connected: function () {
        mercury.subscriptions.push(subscription);
        return mercury.trigger("subscribe", subscription);
      },
      disconnected: function () {
        var currentSubscriptions, i, len, ref, s;
        currentSubscriptions = [];
        ref = mercury.subscriptions;

        for (i = 0, len = ref.length; i < len; i++) {
          s = ref[i];

          if (s.uuid !== uuid) {
            currentSubscriptions.push(s);
          }
        }

        return mercury.subscriptions = currentSubscriptions;
      },
      received: function (message) {
        if (message.deleted) {
          return mercury.trigger("deleted", [subscription, message]);
        } else {
          mercury.trigger("message", [subscription, message]);
          mercury.trigger("uuid:" + uuid, [subscription, message]);

          if (subscription.type) {
            return mercury.trigger("type:" + subscription.type, [subscription, message]);
          }
        }
      },
      history: function () {
        return this.perform("history");
      }
    });
  }

}

export { Mercury };
const MERCURY_DO_NOT_DISTURB_KEY = "mercury:do-not-disturb";
const MERCURY_DO_NOT_DISTURB_ENABLED = "enabled";
const MERCURY_DO_NOT_DISTURB_DISABLED = "disabled";
const MERCURY_DEFAULT_MESSAGE_SOURCE = {
  name: "",
  description: ""
};

class MercuryNotifications {
  static init() {
    this.instance = new MercuryNotifications(".mercury-notifications-button");
    this.instance.connect();
  }

  static unload() {
    if (!this.instance) {
      return true;
    }

    this.instance.disconnect();
    this.instance = null;
  }

  static toHumanDate(date) {
    const today = new Date();
    const yesterday = new Date(today.getTime() - 86400000);

    switch (date.toDateString()) {
      case today.toDateString():
        return "Today";

      case yesterday.toDateString():
        return "Yesterday";

      default:
        return date.toLocaleString("en-us", {
          year: "numeric",
          month: "long",
          day: "numeric"
        });
    }
  }

  static toHumanTime(date) {
    return date.toLocaleString("en-us", {
      hour: "numeric",
      minute: "numeric",
      hour12: true
    });
  }

  constructor(selector) {
    this.$button = $(selector);
    this.$button.sideNav({
      menuWidth: 300,
      edge: 'right'
    });
    this.$list = $(".mercury-notifications-list");
    this.$badge = this.$button.find(".badge");
    this.$toast = $("#mercury-toast-area");
    this.$doNotDisturbSwitch = $("#mercury-sidebar .do-not-disturb-switch input[type=checkbox]");
    this.messages = [];
  }

  connect() {
    if (!Mercury.registration) {
      console.error("Mercury.registration is missing. Can't connect.");
    }

    this.mercury = Mercury.connect(Mercury.registration, Mercury.url);
    Mercury.on("register", reg => {
      this.onRegister(reg);
    });
    Mercury.on("subscribe", sub => {
      Mercury.history(sub);
    });
  }

  disconnect() {
    if (!this.mercury) {
      return true;
    }

    Mercury.disconnect();
  }

  uninstall() {
    Mercury.off("deleted");

    if (this.registration) {
      this.registration.user.subscriptions.forEach(sub => {
        Mercury.off(sub);
      });
    }
  }

  install() {
    Mercury.on("deleted", (sub, msg) => {
      this.onDeleted(sub, msg);
    });
    this.registration.user.subscriptions.forEach(sub => {
      Mercury.on(sub, (sub, msg) => {
        this.onMessage(sub, msg);
      });
    });
    this.$list.on("click", ".dismiss-button", e => {
      this.onDismiss(e);
    });
    this.$button.on("click", e => {
      this.markAsRead(e);
    });
    this.initDoNotDisturbSwitch();
  }

  initDoNotDisturbSwitch() {
    this.$doNotDisturbSwitch.prop('checked', this.getDoNotDisturb());
    this.$doNotDisturbSwitch.on("change", e => {
      this.setDoNotDisturb(this.$doNotDisturbSwitch.prop('checked'));
    });
  }

  setDoNotDisturb(isEnabled) {
    this.$doNotDisturbSwitch.prop('checked', isEnabled);
    window.localStorage.setItem(MERCURY_DO_NOT_DISTURB_KEY, isEnabled ? MERCURY_DO_NOT_DISTURB_ENABLED : MERCURY_DO_NOT_DISTURB_DISABLED);
  }

  getDoNotDisturb() {
    return window.localStorage.getItem(MERCURY_DO_NOT_DISTURB_KEY) === MERCURY_DO_NOT_DISTURB_ENABLED;
  }

  onRegister(registration) {
    this.uninstall();
    this.registration = registration;
    this.registeredAt = Date.now();
    this.install();
  }

  onDeleted(subscription, message) {
    this.removeMessage(message, () => {
      this.$list.find(`[data-uuid=${message.uuid}]`).remove();
      this.removeEmptyDaySections();
    });
    this.updateBadge();
  }

  onDismiss(event) {
    let $card = $(event.target).closest(".mercury-notification-card");

    if ($card.length > 0) {
      $card.css("opacity", 0.5);
      Mercury.destroy($card.data("subscription-uuid"), $card.data("uuid"));
    }
  }

  markAsRead(event) {
    for (var i = 0; i < this.messages.length; i++) {
      if (this.messages[i].read_at === null) {
        Mercury.markAsRead(this.messages[i].subscription_uuid, this.messages[i].uuid);
      }
    }
  }

  onMessage(subscription, message) {
    if (!this.hasMessage(message)) {
      this.messages.push(message);
      const notification = this.buildNotification(subscription, message);
      const createdAt = new Date(message.created_at * 1000);
      this.addNotification(notification, createdAt);
      this.toastMessage(notification);
      this.updateBadge();
    } else if (this.findMessageByUuid(message.uuid) !== message) {
      let indexOfMessage = this.messages.indexOf(this.findMessageByUuid(message.uuid));
      this.messages[indexOfMessage] = message;
      this.updateBadge();
    }
  }

  addNotification(notification, created) {
    // TODO: Don't assume the messages are chronological
    this.findOrCreateDaySection(created).find(".mercury-notification-day-section-notification-list").prepend(notification);
  }

  findOrCreateDaySection(date) {
    return this.findDaySection(date) || this.createDaySection(date);
  }

  removeEmptyDaySections() {
    this.$list.find('.mercury-notification-day-section').filter(function () {
      return $(this).find('.mercury-notification-day-section-notification-list').children().length === 0;
    }).remove();
  }

  findDaySection(date) {
    const key = date.toDateString();
    const $daySection = this.$list.find(`.mercury-notification-day-section[data-key="${key}"]`);

    if ($daySection.length === 1) {
      return $daySection;
    } else {
      return null;
    }
  }

  createDaySection(date) {
    const key = date.toDateString();
    const humanDate = MercuryNotifications.toHumanDate(date);
    const $daySection = $(`
        <div class="mercury-notification-day-section my-4" data-key="${key}">
            <h5 class="mercury-notification-day-section-date my-1">${humanDate}</h5>
            <div class="mercury-notification-day-section-notification-list"></div>
        </div>
      `); // TODO: Don't assume the messages are chronological

    this.$list.prepend($daySection);
    return $daySection;
  }

  findMessageByUuid(uuid) {
    for (var i = 0; i < this.messages.length; i++) {
      if (this.messages[i].uuid === uuid) {
        return this.messages[i];
      }
    }

    return null;
  }

  hasMessage(message) {
    return this.findMessageByUuid(message.uuid) !== null;
  }

  removeMessage(message, callback) {
    let remaining = [];
    this.messages.forEach(m => {
      if (message.uuid !== m.uuid) {
        remaining.push(m);
      } else {
        if (callback) callback(message);
      }
    });
    this.messages = remaining;
  }

  updateBadge() {
    let unreadMessageLength = 0;
    $.each(this.messages, (i, message) => {
      if (message.read_at === null) {
        return unreadMessageLength += 1;
      }
    });
    this.$badge.text(unreadMessageLength);
    this.$badge.toggleClass("on", unreadMessageLength > 0);
  }

  toastMessage(html) {
    if (this.getDoNotDisturb()) {
      return;
    }

    if (Date.now() - this.registeredAt > 5000) {
      this.$toast.html(html);
      this.$toast.fadeIn({
        duration: 500
      });
      setTimeout(() => {
        this.$toast.fadeOut({
          duration: 500
        });
      }, 3000);
    }
  }

  buildDismissButton(message) {
    if (message.dismissable || Mercury.admin) {
      return `
        <div class="dismiss-button-container">
          <i class="material-icons dismiss-button">cancel</i>
        </div>
      `;
    } else {
      return `<div></div>`;
    }
  }

  buildNotification(subscription, message) {
    const source = message.source || MERCURY_DEFAULT_MESSAGE_SOURCE;
    const linked = message.link != undefined;
    return `
      <div class="mercury-notification-card ${source.name} ${linked ? "u-hover--grey" : ""}" data-uuid="${message.uuid}" data-subscription-uuid="${subscription.uuid}">
        ${this.buildDismissButton(message)}
        ${this.messageWrapperTag(message)}
          ${this.messageContent(message, source)}
        ${this.messageClosingTag(message)}
      </div>
    `;
  }

  messageWrapperTag(message) {
    if (message.link != undefined) {
      return `<a class='linked-mercury-notification-wrapper' href='${message.link}'>`;
    } else {
      return `<div class='unlinked-mercury-notification-wrapper'>`;
    }
  }

  messageContent(message, source) {
    const createdAt = new Date(message.created_at * 1000);
    return `
      <div class="notice-header">
        <time class="notice-at" datetime="${createdAt.toISOString()}">${MercuryNotifications.toHumanTime(createdAt)}</time>
        <p class="notice-from">${source.description}</p>
      </div>
      <div class="notice-body">
        ${message.content}
      </div>
    `;
  }

  messageClosingTag(message) {
    return message.link != undefined ? `</a>` : `</div>`;
  }

}

export { MercuryNotifications };